// extracted by mini-css-extract-plugin
export default {"empty-state-wrapper":"EmptyState_empty-state-wrapper__tsjSJ","cta-wrapper":"EmptyState_cta-wrapper__0ovNW"};